import { Alert } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { Outlet } from "react-router-dom";
import { useAuthStore } from "../../../store";
import { canManageLegacyCases } from "../../../utils/legacyCaseAccess";

export default function LegacyCasesGuard() {
  const profile = useAuthStore((state) => state.profile);

  if (!canManageLegacyCases(profile)) {
    return (
      <Alert
        color="red"
        icon={<IconLock />}
        title="Access restricted"
        role="alert"
      >
        Your account needs Legacy Cases access. Contact an administrator or
        medical director.
      </Alert>
    );
  }

  return <Outlet />;
}
